import { render, staticRenderFns } from "./ElementCategoryTableColumn.vue?vue&type=template&id=f20b4188"
import script from "./ElementCategoryTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementCategoryTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports